var map = {
	"./Img-01.jpg": 11115,
	"./Img-02.jpg": 19132,
	"./Img-03.jpg": 40185,
	"./Img-05.jpg": 25127,
	"./Img-07.jpg": 95541,
	"./K.png": 19989,
	"./app-store.png": 12047,
	"./app.png": 24095,
	"./apple-sml.png": 44577,
	"./b.png": 43268,
	"./banner/banner_available.png": 98261,
	"./banner/banner_quality.png": 68499,
	"./banner/banner_tragedy.png": 7834,
	"./blog-grid/author_img.png": 38121,
	"./blog-grid/blog_list1.jpg": 56516,
	"./blog-grid/blog_list2.jpg": 40211,
	"./blog-grid/blog_list3.jpg": 84950,
	"./blog-grid/blog_list4.jpg": 25469,
	"./blog-grid/blog_single.png": 56569,
	"./blog-grid/comment1.png": 21976,
	"./blog-grid/comment2.png": 67731,
	"./blog-grid/post_1.jpg": 83194,
	"./blog-grid/post_2.jpg": 5797,
	"./blog-grid/post_3.jpg": 78632,
	"./blog-grid/post_4.jpg": 8635,
	"./blog-grid/post_img_1.png": 99678,
	"./blog-grid/post_img_2.png": 67029,
	"./blog-grid/post_img_3.png": 97932,
	"./br_logo.png": 78056,
	"./breadcrumb/banner_bg.png": 34214,
	"./breadcrumb/service.png": 25699,
	"./breadcrumb/service_details.png": 99428,
	"./breadcrumb/service_details_one.png": 3313,
	"./brochures/brochure_01.png": 36606,
	"./brochures/brochure_02.png": 22357,
	"./calc.png": 51175,
	"./cart1.jpg": 9885,
	"./cart2.jpg": 72082,
	"./doc_02.png": 90459,
	"./docs/brochure_01.png": 1330,
	"./docs/brochure_02.png": 49513,
	"./docs/doc_01.png": 98174,
	"./docs/doc_02.png": 34901,
	"./docs/whitepaper_01.png": 57431,
	"./docs/whitepaper_02.png": 33500,
	"./docs/whitepaper_03.png": 69413,
	"./docs/whitepaper_04.png": 98986,
	"./erp-home/action_img.png": 67976,
	"./erp-home/background.png": 86438,
	"./erp-home/banner_shap.png": 47679,
	"./erp-home/cloud-computing.png": 38114,
	"./erp-home/cloud_01.png": 15413,
	"./erp-home/cloud_02.png": 13310,
	"./erp-home/cloud_03.png": 999,
	"./erp-home/cloud_04.png": 25832,
	"./erp-home/cloud_05.png": 65777,
	"./erp-home/cloud_06.png": 41114,
	"./erp-home/crm_img1.jpg": 63251,
	"./erp-home/crm_img2.jpg": 37028,
	"./erp-home/crm_img3.jpg": 10625,
	"./erp-home/erp_dashboard.jpg": 61158,
	"./erp-home/erp_icon1.png": 17042,
	"./erp-home/erp_icon2.png": 48009,
	"./erp-home/erp_icon3.png": 69888,
	"./erp-home/erp_icon4.png": 4863,
	"./erp-home/erp_icon5.png": 7926,
	"./erp-home/erp_icon6.png": 21901,
	"./erp-home/growth.png": 91823,
	"./erp-home/img/01.png": 54711,
	"./erp-home/img/02.png": 30780,
	"./erp-home/img/03.png": 83045,
	"./erp-home/img/04.png": 12618,
	"./erp-home/img/05.png": 28179,
	"./erp-home/img/06.png": 32568,
	"./erp-home/img/07.png": 53697,
	"./erp-home/img/08.png": 42182,
	"./erp-home/img/09.png": 7375,
	"./erp-home/img/10.png": 79305,
	"./erp-home/img/11.png": 1184,
	"./erp-home/img/12.png": 79515,
	"./erp-home/img/13.png": 64690,
	"./erp-home/img/14.png": 69549,
	"./erp-home/img/15.png": 15652,
	"./erp-home/img/16.png": 52511,
	"./erp-home/img/17.png": 39222,
	"./erp-home/img/18.png": 16529,
	"./erp-home/img/19.png": 22664,
	"./erp-home/img/20.png": 9844,
	"./erp-home/quote.png": 20964,
	"./erp-home/rocket.png": 99138,
	"./erp-home/settings1.png": 47508,
	"./erp-home/shape.png": 68583,
	"./erp-home/testimonial_img.jpg": 59645,
	"./erp-home/testimonial_img2.jpg": 87491,
	"./error_bg.png": 36964,
	"./favicon.png": 53502,
	"./gareth.png": 31071,
	"./gareth_img_only.png": 77398,
	"./hemdahl-app-screenshot-nobg.png": 32037,
	"./hemdahl-app-screenshot-small.png": 94312,
	"./hemdahl-app-screenshot.png": 93482,
	"./hemdahl-app.jpg": 45739,
	"./hemdahl-app.png": 70675,
	"./home-chat/Messages.jpg": 83375,
	"./home-chat/Messages.png": 7423,
	"./home-chat/book.png": 2308,
	"./home-chat/box.png": 59976,
	"./home-chat/chat.png": 73193,
	"./home-chat/chat_01.png": 97227,
	"./home-chat/chat_02.png": 83408,
	"./home-chat/chat_icon.png": 76541,
	"./home-chat/cloud.png": 81224,
	"./home-chat/dashboard.png": 45879,
	"./home-chat/dot.png": 82894,
	"./home-chat/get_started_bg.png": 73075,
	"./home-chat/john.png": 16268,
	"./home-chat/left_leaf.png": 41761,
	"./home-chat/live_chat.png": 7496,
	"./home-chat/mobile.png": 28581,
	"./home-chat/panguin_img_one.png": 53686,
	"./home-chat/panguin_img_three.png": 44938,
	"./home-chat/panguin_img_two.png": 21800,
	"./home-chat/pluse.png": 63078,
	"./home-chat/richard.png": 29322,
	"./home-chat/right_leaf.png": 56090,
	"./home-chat/skyp_1.png": 8266,
	"./home-chat/skyp_2.png": 57249,
	"./home-chat/support_dashboard.jpg": 84831,
	"./home-chat/triangle.png": 21199,
	"./home-chat/video_icon.png": 30860,
	"./home-event/about.jpg": 70284,
	"./home-event/banner_bg.jpg": 14411,
	"./home-event/chat.png": 99237,
	"./home-event/conference.jpg": 3021,
	"./home-event/digital.jpg": 71079,
	"./home-event/dot.png": 43346,
	"./home-event/image_01.jpg": 79640,
	"./home-event/image_02.jpg": 59623,
	"./home-event/image_03.jpg": 91882,
	"./home-event/image_04.jpg": 28601,
	"./home-event/image_05.jpg": 41724,
	"./home-event/image_06.jpg": 26379,
	"./home-event/instragram1.jpg": 72004,
	"./home-event/instragram2.jpg": 14579,
	"./home-event/instragram3.jpg": 69814,
	"./home-event/instragram4.jpg": 92509,
	"./home-event/instragram5.jpg": 24416,
	"./home-event/instragram6.jpg": 14735,
	"./home-event/leader.png": 87556,
	"./home-event/logo_09.jpg": 50154,
	"./home-event/logo_10.jpg": 26240,
	"./home-event/logo_11.jpg": 77373,
	"./home-event/logo_12.jpg": 67474,
	"./home-event/marker.png": 74457,
	"./home-event/marketing.jpg": 50487,
	"./home-event/meetup.png": 47249,
	"./home-event/price_shap.png": 87051,
	"./home-event/promo.jpg": 45670,
	"./home-event/team1.jpg": 68911,
	"./home-event/team2.jpg": 55296,
	"./home-event/team3.jpg": 6429,
	"./home-event/timer.png": 52660,
	"./home-security/about_img_1.jpg": 67760,
	"./home-security/about_img_2.jpg": 82719,
	"./home-security/apple_icon.png": 32083,
	"./home-security/banner.png": 21953,
	"./home-security/leaf_clients1.png": 74141,
	"./home-security/leaf_clients2.png": 6726,
	"./home-security/mackbook.png": 30212,
	"./home-security/padlock.png": 6509,
	"./home-security/real-estate.png": 80494,
	"./home-security/rocket.png": 73899,
	"./home-security/security_1.png": 11209,
	"./home-security/security_2.png": 46066,
	"./home-security/security_3.png": 11419,
	"./home-security/security_4.png": 1476,
	"./home-security/shap.png": 12189,
	"./home-security/sheld_bg.png": 68507,
	"./home-security/shield.png": 11280,
	"./home-security/windows_icon.png": 62330,
	"./home-software/analytices1.png": 65692,
	"./home-software/analytices2.png": 23799,
	"./home-software/analytices3.png": 78222,
	"./home-software/analytices4.png": 95937,
	"./home-software/analytices5.jpg": 27324,
	"./home-software/analytices6.jpg": 11979,
	"./home-software/analytices7.jpg": 33934,
	"./home-software/analytices8.jpg": 48941,
	"./home-software/case.png": 5980,
	"./home-software/down_bg.png": 84612,
	"./home-software/elements_five.png": 57868,
	"./home-software/elements_four.png": 21404,
	"./home-software/elements_one.png": 97494,
	"./home-software/elements_six.png": 54042,
	"./home-software/elements_three.png": 7082,
	"./home-software/elements_two.png": 19656,
	"./home-software/line_02.png": 92693,
	"./home-software/logo_01.png": 76499,
	"./home-software/logo_02.png": 80888,
	"./home-software/logo_03.png": 2017,
	"./home-software/logo_04.png": 3534,
	"./home-software/logo_05.png": 3031,
	"./home-software/logo_06.png": 79100,
	"./home-software/logo_07.png": 15013,
	"./home-software/logo_08.png": 9986,
	"./home-software/logo_09.png": 491,
	"./home-software/logo_10.png": 83861,
	"./home-software/logo_11.png": 31596,
	"./home-software/logo_12.png": 50599,
	"./home-software/mackbook.png": 62331,
	"./home-software/pie.png": 2752,
	"./home-software/setup_img1.png": 46884,
	"./home-software/setup_img2.png": 60447,
	"./home-software/setup_img3.png": 82358,
	"./home-software/shap_3.png": 56972,
	"./home-software/shap_one.png": 40411,
	"./home-software/shap_two.png": 14089,
	"./home-tracking/activity_icon.png": 48679,
	"./home-tracking/aliexpress.png": 61684,
	"./home-tracking/amazon.png": 56476,
	"./home-tracking/analyze_icon.png": 91244,
	"./home-tracking/apple.png": 72454,
	"./home-tracking/computer_tracking_img.jpg": 53483,
	"./home-tracking/crismas.png": 72346,
	"./home-tracking/cta.png": 91776,
	"./home-tracking/cta_pattern_bg.jpg": 73025,
	"./home-tracking/google.png": 28073,
	"./home-tracking/left-dot.png": 56053,
	"./home-tracking/month.png": 28516,
	"./home-tracking/right-dot.png": 70102,
	"./home-tracking/tesla.png": 74159,
	"./home-tracking/time_icon.png": 81887,
	"./home-tracking/tracking_banner_img.png": 21530,
	"./home-tracking/watch_1.png": 5239,
	"./home-tracking/windows.png": 8717,
	"./home2/action_bg.png": 68734,
	"./home2/file.png": 28830,
	"./home2/inbox.png": 61174,
	"./home2/report.png": 49350,
	"./home2/undraw.png": 34987,
	"./home3/action_image.png": 31551,
	"./home3/dimond.png": 8200,
	"./home3/logo_01.png": 59858,
	"./home3/logo_02.png": 66921,
	"./home3/logo_03.png": 95744,
	"./home3/logo_04.png": 47071,
	"./home3/logo_05.png": 50742,
	"./home3/p_feature1.png": 52943,
	"./home3/prototype_banner_img.png": 23108,
	"./home3/prototype_banner_img2.png": 48396,
	"./home3/psd.png": 20718,
	"./home3/saas.png": 95915,
	"./home3/tab.png": 22006,
	"./home4/1193022.png": 48302,
	"./home4/action_shap.png": 75875,
	"./home4/author_img.png": 59027,
	"./home4/banner_bg.png": 5592,
	"./home4/banner_img.png": 30364,
	"./home4/ca_analysis.png": 84161,
	"./home4/chilling_injury_analysis.png": 76307,
	"./home4/ct_analysis.png": 14598,
	"./home4/data_gap_analysis.png": 1170,
	"./home4/divider.png": 71139,
	"./home4/dot.png": 60937,
	"./home4/excursion_analysis.png": 30359,
	"./home4/freezing_injury_analysis.png": 44677,
	"./home4/hemdahl-app.png": 28890,
	"./home4/humidity_analysis.png": 88084,
	"./home4/icon01.png": 91812,
	"./home4/icon01_alt.png": 2284,
	"./home4/icon02.png": 5375,
	"./home4/icon02_alt.png": 28739,
	"./home4/icon3.png": 43442,
	"./home4/icon_04.png": 40898,
	"./home4/icon_05.png": 4555,
	"./home4/icon_shape1.png": 37714,
	"./home4/icon_shape2.png": 68681,
	"./home4/icon_shape3.png": 90560,
	"./home4/icon_shape4.png": 25535,
	"./home4/pathogen_analysis.png": 99763,
	"./home4/power_gap_analysis.png": 43177,
	"./home4/process_1.png": 5071,
	"./home4/process_2.png": 82612,
	"./home4/process_3.png": 3741,
	"./home4/process_4.png": 10946,
	"./home4/process_5.png": 74603,
	"./home4/setpoint_analysis.png": 89935,
	"./home4/shape.png": 10431,
	"./home4/shelf_life_analysis.png": 11574,
	"./home4/shock_analysis.png": 13801,
	"./home4/team1.jpg": 46196,
	"./home4/team2.jpg": 75907,
	"./home4/work1.png": 71924,
	"./home4/work2.png": 46415,
	"./home4/work3.png": 23750,
	"./home5/01.jpg": 19560,
	"./home5/02.jpg": 4311,
	"./home5/03.jpg": 40474,
	"./home5/banner_img.png": 75439,
	"./home5/design1.png": 8982,
	"./home5/design2.png": 99661,
	"./home5/featured_bg_shape.png": 4575,
	"./home5/featured_img1.png": 96710,
	"./home5/icon1.png": 11589,
	"./home5/icon2.png": 57582,
	"./home5/icon3.png": 86807,
	"./home5/icon_shape.png": 86188,
	"./home5/php.jpg": 36929,
	"./home5/shap_tecture.png": 59672,
	"./home6/dashboard.jpg": 24982,
	"./home6/featured_img_one.jpg": 1851,
	"./home6/featured_img_two.jpg": 60985,
	"./home6/feedback_img_one.png": 26448,
	"./home6/feedback_img_three.png": 57712,
	"./home6/feedback_img_two.png": 98450,
	"./home6/logo_01.png": 35831,
	"./home6/logo_02.png": 28252,
	"./home6/logo_03.png": 64165,
	"./home6/logo_04.png": 93738,
	"./home6/logo_05.png": 25651,
	"./home6/shape-1.png": 29723,
	"./home6/shape2.png": 5639,
	"./home6/trust_img.png": 65268,
	"./home6/trust_img2.png": 21340,
	"./home7/01.png": 85494,
	"./home7/02.png": 99469,
	"./home7/03.png": 45572,
	"./home7/app.png": 44318,
	"./home7/banner.png": 67765,
	"./home7/google_icon.png": 956,
	"./home7/iPhoneX2.png": 25654,
	"./home7/iPhonex.png": 50550,
	"./home7/screenshot1.png": 91010,
	"./home7/screenshot2.png": 39193,
	"./home7/screenshot3.png": 42288,
	"./home7/screenshot4.png": 85135,
	"./home7/screenshot5.png": 46118,
	"./home7/team_01.jpg": 43572,
	"./home7/team_02.jpg": 89635,
	"./home7/team_03.jpg": 30150,
	"./home7/team_04.jpg": 65581,
	"./home7/testimonial_author_img.png": 29478,
	"./home7/text_one.png": 56571,
	"./home7/text_three.png": 90431,
	"./home7/text_two.png": 34249,
	"./home8/banner_img.png": 12104,
	"./home8/dot.png": 57317,
	"./home8/fact.png": 79800,
	"./home8/service_item_03.png": 21095,
	"./home9/featured_img.png": 27299,
	"./home9/featured_img_two.png": 11776,
	"./home9/flag.png": 87923,
	"./home9/footer.png": 49576,
	"./home9/icon1.png": 32793,
	"./home9/icon2.png": 76706,
	"./home9/icon3.png": 97835,
	"./home9/icon4.png": 47924,
	"./home9/icon5.png": 80957,
	"./home9/icon6.png": 83398,
	"./home9/icon7.png": 22415,
	"./home9/icon8.png": 97464,
	"./home9/icon_shape.png": 43720,
	"./home9/icon_shape_two.png": 57075,
	"./home9/logo1.png": 20515,
	"./home9/logo2.png": 67304,
	"./home9/logo3.png": 77521,
	"./home9/logo4.png": 94430,
	"./home9/logo5.png": 46919,
	"./home9/logo6.png": 44268,
	"./home9/logo7.png": 80181,
	"./home9/logo8.png": 9330,
	"./home9/mac.png": 27048,
	"./home9/map.png": 88979,
	"./home9/shape-footer.png": 81236,
	"./home9/shape.png": 7754,
	"./home9/shape_two.png": 69401,
	"./home9/testimonial_img.png": 5332,
	"./home9/testimonial_img2.png": 46876,
	"./home9/triangle_bottom.png": 3399,
	"./home9/triangle_top.png": 60397,
	"./hosting/action_img.png": 61439,
	"./hosting/business1.png": 54226,
	"./hosting/business2.png": 19369,
	"./hosting/h_blog1.jpg": 38513,
	"./hosting/h_blog2.jpg": 80742,
	"./hosting/hosting-image.png": 78115,
	"./hosting/hosting_action_bg.png": 89190,
	"./hosting/icon1.png": 99901,
	"./hosting/icon10.png": 91337,
	"./hosting/icon2.png": 16134,
	"./hosting/icon3.png": 1231,
	"./hosting/icon4.png": 89008,
	"./hosting/icon5.png": 21113,
	"./hosting/icon6.png": 7106,
	"./hosting/icon7.png": 70763,
	"./hosting/icon8.png": 74108,
	"./hosting/icon9.png": 7973,
	"./hosting/line_01.png": 24901,
	"./hosting/line_02.png": 97070,
	"./hosting/line_03.png": 96567,
	"./hosting/line_04.png": 74424,
	"./hosting/line_05.png": 11905,
	"./hosting/line_06.png": 54474,
	"./hosting/line_07.png": 86387,
	"./hosting/line_08.png": 44116,
	"./hosting/map.png": 88271,
	"./hosting/region_map.png": 15930,
	"./ifpa_member.png": 90335,
	"./karl.png": 48982,
	"./karl_img_only.png": 95837,
	"./login_img.png": 94617,
	"./login_img2.png": 93711,
	"./logo-3-2x.png": 16102,
	"./logo-old (2).png": 36950,
	"./logo-old.png": 10713,
	"./logo-sticky-2x.png": 20606,
	"./logo-sticky.png": 58661,
	"./logo-sticky2.png": 85843,
	"./logo-sticky3.png": 35082,
	"./logo-sticky4.png": 19749,
	"./logo.png": 62077,
	"./logo2.png": 71163,
	"./logo2x-2.png": 29766,
	"./logo2x.png": 3435,
	"./logo3.png": 22162,
	"./logo4.png": 3725,
	"./logo7.png": 13046,
	"./logo8.png": 24529,
	"./mega-menu-img/Prototyping_Tool.jpg": 99831,
	"./mega-menu-img/analytices.jpg": 96142,
	"./mega-menu-img/coming_img.jpg": 85686,
	"./mega-menu-img/erp.jpg": 50232,
	"./mega-menu-img/home-animation.jpg": 25071,
	"./mega-menu-img/home-chat.jpg": 50131,
	"./mega-menu-img/home-event.jpg": 76821,
	"./mega-menu-img/home-security.jpg": 60611,
	"./mega-menu-img/home-track.jpg": 85944,
	"./mega-menu-img/home1.jpg": 15733,
	"./mega-menu-img/home10.jpg": 40345,
	"./mega-menu-img/home11.jpg": 19292,
	"./mega-menu-img/home12.jpg": 11275,
	"./mega-menu-img/home13.jpg": 33230,
	"./mega-menu-img/home14.jpg": 95701,
	"./mega-menu-img/home15.jpg": 87832,
	"./mega-menu-img/home16.jpg": 25287,
	"./mega-menu-img/home17.jpg": 69450,
	"./mega-menu-img/home2.jpg": 89482,
	"./mega-menu-img/home3.jpg": 45319,
	"./mega-menu-img/home4.jpg": 39324,
	"./mega-menu-img/home5.jpg": 60377,
	"./mega-menu-img/home6.jpg": 53262,
	"./mega-menu-img/home7.jpg": 31307,
	"./mega-menu-img/home8.jpg": 99696,
	"./mega-menu-img/home9.jpg": 51917,
	"./mega-menu-img/hosting.jpg": 44913,
	"./mega-menu-img/icon/app-d.png": 29467,
	"./mega-menu-img/icon/blup.png": 78680,
	"./mega-menu-img/pos.jpg": 45309,
	"./mega-menu-img/saas2-slider.png": 54243,
	"./mega-menu-img/support.jpg": 70082,
	"./new-home/back_bg.png": 45986,
	"./new-home/banner.png": 61645,
	"./new-home/briteverify.png": 73780,
	"./new-home/campfire.png": 45620,
	"./new-home/email.png": 47855,
	"./new-home/kissmetrics.png": 50846,
	"./new-home/metorik.png": 25618,
	"./new-home/nicereply-1.png": 98924,
	"./new-home/p-1.png": 90769,
	"./new-home/p-2.png": 60602,
	"./new-home/p-3.png": 78179,
	"./new-home/tab.png": 67642,
	"./new-home/tab_2.png": 6293,
	"./new-home/tab_3.png": 23404,
	"./new-home/ticket-support.png": 50853,
	"./new-home/tree-left.png": 79013,
	"./new-home/tree-right.png": 64582,
	"./new-home/tree.png": 13295,
	"./new-home/update.png": 16308,
	"./new-home/webhooks.png": 43781,
	"./new-home/wedsite.png": 94466,
	"./new/01.png": 84052,
	"./new/0111.png": 56014,
	"./new/02.png": 58543,
	"./new/0222.png": 40075,
	"./new/03.png": 19526,
	"./new/04.png": 68921,
	"./new/05.png": 62672,
	"./new/06.png": 33963,
	"./new/app_screen.png": 53313,
	"./new/blog/blog_grid_1.jpg": 75343,
	"./new/blog/blog_grid_2.jpg": 61728,
	"./new/blog/blog_grid_3.jpg": 957,
	"./new/blog/blog_grid_4.jpg": 69494,
	"./new/blog/blog_grid_5.jpg": 32659,
	"./new/blog/blog_grid_6.jpg": 81028,
	"./new/blog/blog_grid_7.jpg": 59073,
	"./new/blog/blog_grid_8.jpg": 84282,
	"./new/case/case_01.jpg": 8590,
	"./new/case/case_02.jpg": 64729,
	"./new/case/case_03.jpg": 67356,
	"./new/case/case_04.jpg": 91143,
	"./new/case/case_05.jpg": 52138,
	"./new/case/case_06.jpg": 19477,
	"./new/case/case_07.jpg": 12216,
	"./new/case/case_08.jpg": 94947,
	"./new/case/case_09.jpg": 30246,
	"./new/case/case_10.jpg": 10124,
	"./new/case/case_11.jpg": 31817,
	"./new/case/case_12.jpg": 5086,
	"./new/case/case_details_01.jpg": 5811,
	"./new/case/case_details_02.jpg": 63236,
	"./new/case/case_details_03.jpg": 53185,
	"./new/case/parallax.png": 43839,
	"./new/coming_soon_bg.png": 68932,
	"./new/company.jpg": 18636,
	"./new/cup.png": 55377,
	"./new/digital_img.png": 47425,
	"./new/error.png": 71119,
	"./new/features_01.png": 36152,
	"./new/feedback_shap.png": 49811,
	"./new/home-split/contact.png": 37130,
	"./new/iPhoneX.png": 31032,
	"./new/icon.png": 85558,
	"./new/icon/icon1.png": 24539,
	"./new/icon/icon2.png": 46208,
	"./new/icon2.png": 34678,
	"./new/icon3.png": 12767,
	"./new/intregration_1.png": 98688,
	"./new/intregration_2.png": 80696,
	"./new/intregration_3.png": 1825,
	"./new/intregration_4.png": 3342,
	"./new/laptop.png": 14605,
	"./new/laptop_two.png": 91430,
	"./new/leaf.png": 14857,
	"./new/line_01.png": 42933,
	"./new/line_02.png": 6206,
	"./new/line_03.png": 81991,
	"./new/logo_01.png": 52432,
	"./new/logo_02.png": 17835,
	"./new/logo_03.png": 54178,
	"./new/logo_04.png": 46973,
	"./new/logo_05.png": 25844,
	"./new/member_01.jpg": 85921,
	"./new/new_shape.png": 88853,
	"./new/phone.png": 72733,
	"./new/price_bg.png": 83902,
	"./new/shape_bg.png": 17362,
	"./new/solution_01.jpg": 86064,
	"./new/solution_02.jpg": 84063,
	"./new/startup_banner_bg.png": 92359,
	"./new/startup_banner_img.png": 96573,
	"./new/startup_shap.png": 10453,
	"./new/tab_shape_bg.png": 68698,
	"./new/testimonial_bg.png": 77748,
	"./new/testimonial_bg_shap.png": 34271,
	"./new/testimonial_bg_two.png": 64191,
	"./new/video_bg.jpg": 79728,
	"./new/video_img_01.png": 6804,
	"./new/video_img_02.jpg": 6879,
	"./new/web_image.jpg": 34001,
	"./new_logo.png": 57652,
	"./news/app-news.png": 20157,
	"./news/food-news.png": 50460,
	"./news/news-02.png": 64708,
	"./news/news_01.jpg": 21661,
	"./news/news_02.jpg": 11762,
	"./news/news_03.jpg": 96047,
	"./news/news_04.jpg": 1732,
	"./pdf.png": 72036,
	"./pink_container_ship.png": 631,
	"./play-store.png": 15730,
	"./portfolio-details/pr_details1.jpg": 40736,
	"./portfolio-details/pr_details2.jpg": 31055,
	"./portfolio-details/pr_details3.jpg": 54674,
	"./portfolio-details/pr_details4.jpg": 78273,
	"./portfolio/2-columns/grid1.jpg": 16279,
	"./portfolio/2-columns/grid2.jpg": 31528,
	"./portfolio/2-columns/grid3.jpg": 75045,
	"./portfolio/2-columns/grid4.jpg": 30046,
	"./portfolio/2-columns/grid5.jpg": 61531,
	"./portfolio/2-columns/grid6.jpg": 35084,
	"./portfolio/2-columns/grid7.jpg": 73129,
	"./portfolio/2-columns/grid8.jpg": 94418,
	"./portfolio/3-columns/3_col_1.jpg": 13811,
	"./portfolio/3-columns/3_col_10.jpg": 65035,
	"./portfolio/3-columns/3_col_11.jpg": 86990,
	"./portfolio/3-columns/3_col_12.jpg": 94105,
	"./portfolio/3-columns/3_col_2.jpg": 19652,
	"./portfolio/3-columns/3_col_3.jpg": 14049,
	"./portfolio/3-columns/3_col_4.jpg": 88562,
	"./portfolio/3-columns/3_col_5.jpg": 44591,
	"./portfolio/3-columns/3_col_6.jpg": 30976,
	"./portfolio/3-columns/3_col_7.jpg": 82109,
	"./portfolio/3-columns/3_col_8.jpg": 7838,
	"./portfolio/3-columns/3_col_9.jpg": 55675,
	"./portfolio/full-width/full_1.jpg": 33915,
	"./portfolio/full-width/full_10.jpg": 96547,
	"./portfolio/full-width/full_11.jpg": 31846,
	"./portfolio/full-width/full_12.jpg": 89617,
	"./portfolio/full-width/full_2.jpg": 91116,
	"./portfolio/full-width/full_3.jpg": 29161,
	"./portfolio/full-width/full_4.jpg": 8474,
	"./portfolio/full-width/full_5.jpg": 72311,
	"./portfolio/full-width/full_6.jpg": 87560,
	"./portfolio/full-width/full_7.jpg": 31077,
	"./portfolio/full-width/full_8.jpg": 5590,
	"./portfolio/full-width/full_9.jpg": 92051,
	"./pos/High-end-all-in-one-dual-screen.png": 73444,
	"./pos/b_dashboard.png": 31018,
	"./pos/cash-register.png": 56744,
	"./pos/chat.png": 41391,
	"./pos/credit-card.png": 68271,
	"./pos/delivery-truck.png": 9267,
	"./pos/ezgif-1-997e5035cba4.png": 19424,
	"./pos/fotter_shap.png": 76996,
	"./pos/icon1.png": 99045,
	"./pos/icon2.png": 71214,
	"./pos/icon3.png": 70711,
	"./pos/item1.png": 6771,
	"./pos/item2.png": 32280,
	"./pos/item3.png": 4993,
	"./pos/laptop.png": 76453,
	"./pos/leaf-left.png": 15631,
	"./pos/leaf-right.png": 5632,
	"./pos/mailbox.png": 31505,
	"./pos/man.png": 62281,
	"./pos/pattern_01.png": 34661,
	"./pos/pattern_02.png": 32238,
	"./pos/people.png": 24936,
	"./pos/pos.png": 76915,
	"./pos/pos_about_img.png": 60869,
	"./pos/pos_blog_1.png": 13576,
	"./pos/pos_blog_2.png": 75555,
	"./pos/pos_blog_3.png": 85722,
	"./pos/pos_slideshow1.jpg": 35505,
	"./pos/pos_slideshow2.jpg": 7750,
	"./pos/pos_slideshow3.jpg": 50883,
	"./pos/shape.png": 32446,
	"./pos/shape_bg.png": 40874,
	"./pos/statistics.png": 4932,
	"./pos/tab_pattern.png": 7971,
	"./pos/wave_two.png": 58569,
	"./pos/women.png": 84563,
	"./price/one.png": 49060,
	"./price/three.png": 36468,
	"./price/two.png": 53750,
	"./process/ASAN-logo-icon.png": 29697,
	"./process/Avast_Antivirus.png": 88569,
	"./process/UTorrent_(logo).png": 58018,
	"./process/btFMmsoh.png": 17762,
	"./process/logo-slack.png": 54112,
	"./process/png-logo-design.png": 96334,
	"./qoute.png": 49734,
	"./saas/map.png": 77583,
	"./seo/bike.png": 53521,
	"./seo/car.png": 26098,
	"./seo/cloud.png": 93363,
	"./seo/cloud_bg.png": 21681,
	"./seo/features_img.png": 92259,
	"./seo/features_img_two.png": 90368,
	"./seo/footer_bg.png": 23905,
	"./seo/hemdahl-screenshot01.png": 90723,
	"./seo/icon1.png": 50992,
	"./seo/icon2.png": 22283,
	"./seo/icon3.png": 1154,
	"./seo/icon4.png": 5405,
	"./seo/icon5.png": 72372,
	"./seo/image-old.png": 34035,
	"./seo/image.png": 10443,
	"./seo/logo_01.png": 93025,
	"./seo/logo_02.png": 44042,
	"./seo/logo_03.png": 99251,
	"./seo/logo_04.png": 99292,
	"./seo/logo_05.png": 28709,
	"./seo/logo_06.png": 56910,
	"./seo/logo_07.png": 99927,
	"./seo/logo_08.png": 49392,
	"./seo/logo_09.png": 46297,
	"./seo/shap.png": 68144,
	"./seo/studies_img_one.jpg": 46502,
	"./seo/studies_img_three.jpg": 51842,
	"./seo/studies_img_two.jpg": 4976,
	"./seo/triangle_one.png": 39375,
	"./seo/triangle_three.png": 77027,
	"./seo/triangle_two.png": 34925,
	"./svg.svg": 65018,
	"./teams/team_01.jpg": 68014,
	"./teams/team_02.jpg": 48281,
	"./teams/team_03.jpg": 77756,
	"./teams/team_04.jpg": 79303,
	"./teams/team_10.jpg": 63884,
	"./teams/team_12.jpg": 70174,
	"./teams/team_5.jpg": 19538,
	"./teams/team_6.jpg": 29437,
	"./teams/team_7.jpg": 90208,
	"./teams/team_8.jpg": 79323,
	"./teams/team_9.jpg": 24542,
	"./whitepapers/whitepaper_01.jpg": 25162,
	"./whitepapers/whitepaper_01.png": 25902,
	"./whitepapers/whitepaper_02.jpg": 76149,
	"./whitepapers/whitepaper_02.png": 97701,
	"./whitepapers/whitepaper_03.jpg": 85240,
	"./whitepapers/whitepaper_03.png": 68284,
	"./whitepapers/whitepaper_04.png": 68243
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87958;